import axios from "axios"
import { VERSION } from "../config";
const _MODULE = `/member/${VERSION}/member/amount`;
export default {
  /***
   * 会员金额变更分页
   */
  changePage(data) {
    return axios({
      url: `${_MODULE}/change/page`,
      method: `POST`,
      data
    })
  }
}


// WEBPACK FOOTER //
// ./src/apis/src/memberAmount.js